import { Controller } from "@hotwired/stimulus"

// Card #4685: per-phase "show more/less" over a single sprint week column's
// own project-tile list. Deliberately one controller instance PER COLUMN
// (mounted inside each week's drop zone, not once for the whole board) so
// expanding one phase's list never affects any other phase's list.
//
// Every tile is already rendered server-side -- this is a pure client-side
// visibility toggle, not a fetch/paginate-from-server flow.
//
// Mount:
//   data-controller="sprint-column-pagination"
//   data-sprint-column-pagination-limit-value="5"
// Each tile wrapper:
//   data-sprint-column-pagination-target="item"
// The toggle button (only rendered server-side when there's overflow):
//   data-sprint-column-pagination-target="toggle"
export default class extends Controller {
  static targets = ["item", "toggle"]
  static values = { limit: { type: Number, default: 5 }, expanded: { type: Boolean, default: false } }

  connect() {
    this.apply()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.apply()
  }

  apply() {
    this.itemTargets.forEach((item, index) => {
      item.classList.toggle("hidden", !this.expandedValue && index >= this.limitValue)
    })

    if (!this.hasToggleTarget) return

    const hiddenCount = this.itemTargets.length - this.limitValue
    this.toggleTarget.textContent = this.expandedValue ? "Show less" : `Show ${hiddenCount} more`
  }
}
